import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Dialog } from 'primeng/dialog';
import { Product } from '../../shared/product';

/**
 * Modal dialog for selecting a global product category.
 *
 * Wraps the `ProductGlobalCategorySelectorComponent` inside a PrimeNG dialog.
 * When the user confirms, `selectedProductCategory` is emitted via
 * `selectedProductCategoryEmitter`.  `displayChange` emits `false` on hide
 * to support two-way binding on the `display` input.
 *
 * `ngOnChanges` tracks `selectedProduct` to seed `firstSelectedProduct` (the
 * PRODID of the first element), which drives the selector's initial state.
 */
@Component({
  selector: 'app-select-product-category',
  templateUrl: './select-product-category.component.html',
  styleUrl: './select-product-category.component.css',
  encapsulation: ViewEncapsulation.None
})
export class SelectProductCategoryComponent implements OnInit, OnChanges, OnDestroy {

  selectedProductCategory: string = null;

  firstSelectedProduct: number = 0;

  /** Dialog header text. */
  @Input() header: string = "Выбрать категорию";

  modal: boolean = true;
  loading: boolean;

  /** Controls dialog visibility; supports two-way binding via `displayChange`. */
  @Input() display: boolean = false;
  /** Products whose category is being assigned; seeds `firstSelectedProduct` from index 0. */
  @Input() selectedProduct: Product[] = null;

  /** Emits the selected category string when the user confirms. */
  @Output() selectedProductCategoryEmitter: EventEmitter<string> = new EventEmitter();
  /** Emits `false` on dialog hide to support two-way `[(display)]` binding. */
  @Output() displayChange = new EventEmitter();
  constructor(
  ) { }

  /** No subscriptions to clean up. */
  ngOnDestroy(): void {
  }

  /** No-op initialisation. */
  ngOnInit(): void {
    console.log('*** SelectProductCategoryComponent ngOnInit');
  }

  /** Reacts to `selectedProduct` changes — extracts PRODID of first element into `firstSelectedProduct`. */
  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];
      environment.production || console.log('*** SelectProductCategoryComponent ngOnChanges (actual): ' + propName + ' ' + JSON.stringify(change.currentValue));

      switch (propName) {
        case 'display':
          break;

        case 'selectedProduct':
          this.firstSelectedProduct = (this.selectedProduct.length > 0) ? this.selectedProduct[0].PRODID : 0;
          break;
      }
    }
  }

  /** No-op — called by PrimeNG dialog `(onShow)`. */
  onShowDialog() {
    environment.production || console.log('*** SelectProductCategoryComponent onShow: ');
  }

  /** Emits `false` via `displayChange` to close the dialog. */
  onHideDialog() {
    environment.production || console.log('*** SelectProductCategoryComponent onHide');
    this.displayChange.emit(false);
  }

  /** Emits `selectedProductCategory` and closes the dialog. */
  onConfirm(text: string) {
    environment.production || console.log('*** SelectProductCategoryComponent onConfirm: ' + text);
    environment.production || console.log('*** SelectProductCategoryComponent onConfirm: ' + JSON.stringify(this.selectedProductCategory));
    this.selectedProductCategoryEmitter.emit(this.selectedProductCategory);
    this.display = false;
  }

  /** Stores the category string emitted by the inner `ProductGlobalCategorySelectorComponent`. */
  onSelectedProductCategory(event) {
    console.log('*** SelectProductCategoryComponent onSelectedProductCategory: ' + JSON.stringify(event));
    this.selectedProductCategory = event;
  }
}
